import classNames from "classnames";

import AscButton from "../AscButton/AscButton";
import { FeaturedChallengeBannerIllustration } from "../AscIllustrations";
import AscLink from "../AscLink/AscLink";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import styles from "./AscFeaturedChallengeBanner.module.scss";

export interface AscFeaturedChallengeBannerProps {
  className?: string;
  challengeName: string;
  skillName: string;
  challengePath: string;
  loading?: boolean;
}

export default function AscFeaturedChallengeBanner({
  className,
  challengeName,
  skillName,
  challengePath,
  loading = false,
}: AscFeaturedChallengeBannerProps) {
  return (
    <div
      data-testid="asc-featured-challenge-banner"
      className={classNames(
        styles.ground,
        {
          [styles.loading]: loading,
        },
        className
      )}
    >
      <FeaturedChallengeBannerIllustration className={styles.illustration} />
      <div className={styles.content}>
        <div className={styles.textContent}>
          <AscHeading level={3} className={styles.challengeName}>
            {challengeName}
          </AscHeading>
          <div className={styles.skillName}>{skillName}</div>
        </div>
        <AscLink href={challengePath} className={styles.exploreBtn}>
          <AscButton variant="white" size="large" className={styles.exploreBtn}>
            Explore
          </AscButton>
        </AscLink>
      </div>
    </div>
  );
}
